export default __webpack_public_path__ + "static/media/pic_ai_3.939ed231.png";